/**
 * Cookie manager javascript file
 */

/**
 * Checks if the browser accepts cookies.
 * @returns {boolean} True if cookies are enabled, false otherwise.
 */
function areCookiesEnabled() {
  try {
    document.cookie = 'testcookie=1; path=/';
    const result = document.cookie.indexOf('testcookie') !== -1;
    document.cookie = 'testcookie=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    return result;
  } catch (e) {
    return false; // Error often thrown when cookies are disabled or storage is full
  }
}

/**
 * Set a value, preferring cookies and falling back to localStorage.
 * @param {string} name
 * @param {string} value
 * @param {number} days
 */
export function setCookie(name, value, days) {
  if (areCookiesEnabled()) {
    // 1. Set Standard Cookie
    const d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString();
    document.cookie = `${name}=${value};${expires};path=/;SameSite=Lax`;
  } else {
    // 2. Fallback to localStorage
    try {
      localStorage.setItem(name, value);
      // Note: localStorage does not automatically handle expiration,
      // so we manually store the expiration time as a separate item.
      const expiryTime = Date.now() + (days * 24 * 60 * 60 * 1000);
      localStorage.setItem(`${name}_expiry`, expiryTime);
    } catch (e) {
      console.warn('LocalStorage is full or disabled.');
    }
  }
}

/**
 * Get a value, preferring cookies and falling back to localStorage.
 * @param {string} name
 * @returns {null|string}
 */
export function getCookie(name) {
  // 1. Try Standard Cookie first (your original logic)
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }

  // 2. If cookie not found, check localStorage
  try {
    const value = localStorage.getItem(name);
    const expiryTime = localStorage.getItem(`${name}_expiry`);

    if (value && expiryTime) {
      // Check if the localStorage item has expired
      if (Date.now() < parseInt(expiryTime, 10)) {
        return value;
      } else {
        // If expired, clean up and return null
        localStorage.removeItem(name);
        localStorage.removeItem(`${name}_expiry`);
        return null;
      }
    }
  } catch (e) {
    // localStorage check failed (e.g., security error, disabled)
    return null;
  }

  return null;
}


/**
  * Deletes a cookie and its localStorage fallback.
  * @param {string} name
  */
export function deleteOldCookie(name) {

  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax";

  try {
    // Only attempt to remove if the item actually exists.
    if (localStorage.getItem(name) !== null) {
      localStorage.removeItem(name);
      localStorage.removeItem(`${name}_expiry`);
    }
  } catch (e) {
    // This only triggers if LocalStorage is totally blocked by the browser.
    console.error("Storage access denied by browser settings.");
  }
}
